import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import fileDownload from 'js-file-download';

import { apiRequestWithResponse } from 'app/utils/request/api';

const path = 'admin/bills/:billId/pdf' as const;

export function useDownloadBill() {
  return useMutation({
    mutationFn: async (billId: number) => {
      const response = await apiRequestWithResponse({
        path,
        params: { billId: billId.toString() },
      });

      const headers =
        response.headers.get('Content-Disposition')?.split('; ') ?? [];

      const filename =
        headers.length === 3
          ? headers[2].split("filename*=utf-8''")[1]
          : headers[1].split('filename=')[1].replaceAll('"', '');

      const blobResponse = await response.blob();

      fileDownload(
        blobResponse,
        decodeURIComponent(filename),
        'application/pdf'
      );
    },
    onError: () => {
      message.error('Error downloading bill PDF');
    },
  });
}
